import { CDN_LINK } from "@globalConfig";
import FuelEco from "@/pages/car-info/carTracking/components/carDetailsSection/FuelEco/FuelEco";
import stl from "./carDetailsSection.module.css";
import SingleCarCC from "./SingleCarCC";

const SinlgePanel = (props) => {

  return (
    <>
      <div
        id={props.hasIdForScroll ? "scrollMeMazeedNew" : undefined}
        className={[
          "scrollTmeMF" + props.idSep,
          stl.singlePanContainer,
          props.isActive ? stl.darkBG : undefined,
        ].join(" ")}
      >
        <div className={stl.spHead} onClick={props.setNewPan}>
          <h3>{props.title}</h3>

          <img
            className={props.isActive ? stl.rotateImage : undefined}
            src={CDN_LINK + "/assets/images/roundArrow.svg"}
            alt="icn"
            width={"24px"}
            height={"24px"}
          />
        </div>
        {props.has2columns ? (
          props.isActive ? (
            <div
              className={[
                stl.doubleCol,
                stl.panData,
                props.isActive ? stl.activePan : undefined,
              ].join(" ")}
            >
              {props.data &&
                Object.keys(props.data).map((key, idx) => {
                  const item = props.data[key];

                  return (
                    <SingleCarCC
                      title={item.label}
                      icon={item.icon}
                      field={item.name}
                      key={"SCCC" + idx}
                      colorCode={item.code}
                    />
                  );
                })}
              {props.fuelEco && <FuelEco fuelEco={props.fuelEco} />}
            </div>
          ) : (
            <></>
          )
        ) : (
          <div
            className={[
              stl.panData,
              props.isActive ? stl.activePan : undefined,
            ].join(" ")}
          >
            {props.data.map((item, idx) => {
                return (
                  
                <div key={"sr" + idx} className={stl.rowCC} dangerouslySetInnerHTML={{ __html: item.name.replace(/\n/g, "<br/>") }}>
                  {/* {item.name.replace(/\n/g, "<br/>")} */}
                </div>
                );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default SinlgePanel;
